import { render, staticRenderFns } from "./Notificacoes.vue?vue&type=template&id=f4898554"
import script from "./Notificacoes.vue?vue&type=script&lang=js"
export * from "./Notificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports